import React, { useState, useEffect, useRef } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { store } from '../../Store/store';
import { currencySymbols } from '../../Common/CommonVariables';

const TestAndRevenueComponent = ({ testChartLoader, topTestDetails, setSelectedRevenueMonth }) => {
    const [selectedMonth, setSelectedMonth] = useState(getFormattedMonth(new Date()));
    const [lastThreeMonths, setLastThreeMonths] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // for outside click detection
    const userInfo = store.getState();

    const [sortBy, setSortBy] = useState('Test_NetAmount');
    const sortedTests = [...topTestDetails].sort((a, b) => {
        if (sortBy === 'Count') {
            return b.Count - a.Count;
        } else {
            return b.Test_NetAmount - a.Test_NetAmount;
        }
    });

    function getFormattedMonth(date) {
        return date.toLocaleString('en-US', { month: 'short', year: 'numeric' });
    }

    function generateLastThreeMonths() {
        const months = [];
        const today = new Date();
        for (let i = 2; i >= 0; i--) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            months.push(getFormattedMonth(d));
        }
        return months;
    }

    useEffect(() => {
        setLastThreeMonths(generateLastThreeMonths());
    }, []);

    const handleMonthSelect = (month) => {
        setSelectedMonth(month);
        setIsDropdownOpen(false);
        if (setSelectedRevenueMonth) setSelectedRevenueMonth(month);
    };

    // Close on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="col-md-6 col-lg-4" style={{ position: 'relative' }}>
            <div className="bg-white rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0">Tests & Revenue</h5>

                    <div className="dropdown" style={{ position: 'relative' }} ref={dropdownRef}>
                        <button
                            className="btn custom-sumbitbtn py-2 px-2"
                            type="button"
                            id="monthDropdown"
                            style={{ fontSize: '12px' }}
                            onClick={() => setIsDropdownOpen((prev) => !prev)} // toggle open/close
                        >
                            {selectedMonth} &nbsp;
                            <span className="dropdown-toggle" style={{ fontSize: '10px' }}></span>
                        </button>
                        <ul
                            className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}
                            aria-labelledby="monthDropdown"
                            style={{ position: 'absolute', top: '100%', right: 0 }}
                        >
                            {lastThreeMonths.map((month) => (
                                <li key={month}>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => handleMonthSelect(month)}
                                    >
                                        {month}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Loader */}
                {testChartLoader ? (
                    <div className="centered-message-loader text-center py-4">
                        <FaSpinner
                            style={{ width: '50px', height: '50px', color: 'green' }}
                            className="fa-spin"
                        />
                    </div>
                ) : topTestDetails.length > 0 ? (
                    <div className="card border mb-2" style={{ fontSize: '12px' }}>
                        <div className="card-header fw-bold d-flex select-with-custom-options justify-content-end align-items-end p-1">
                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                className="form-select form-select-sm w-auto cursor-pointer mr-0"
                                style={{ fontSize: '10px' }}
                            >
                                <option value="Test_NetAmount" className="test-revenue-select-option">
                                    Sort by Revenue
                                </option>
                                <option value="Count" className="test-revenue-select-option">
                                    Sort by Count
                                </option>
                            </select>
                        </div>

                        <div
                            className="px-2"
                            style={{
                                maxHeight: topTestDetails.length > 2 ? '240px' : 'auto',
                                overflowY: topTestDetails.length > 2 ? 'auto' : 'visible',
                            }}
                        >
                            {sortedTests.map((test, idx) => (
                                <div
                                    key={idx}
                                    className="d-flex justify-content-between align-items-center border-bottom py-1"
                                >
                                    <div className="flex-grow-1">
                                        <div className="fw-semibold">{test.TestName}</div>
                                        <small className="text-muted">Count: {test.Count}</small>
                                    </div>
                                    <div className="text-end">
                                        <span className="badge bg-light text-dark px-3 py-2">
                                            {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
                                            {test.Test_NetAmount}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="alert alert-warning p-2" style={{ fontSize: '12px' }}>
                        No records found.
                    </div>
                )}
            </div>
        </div>
    );
};

export default TestAndRevenueComponent;
